import { render, staticRenderFns } from "./OrderDetailRow.vue?vue&type=template&id=14c1cca0"
import script from "./OrderDetailRow.vue?vue&type=script&lang=js"
export * from "./OrderDetailRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports